import React from 'react'
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import 'swiper/swiper-bundle.css';
import './trusted.css'

const TrustedLogo = () => {
  return (
    <>
        <section className="trustedLogo">
            <h4>Trusted By 500,000+ Customers</h4>
            <Swiper spaceBetween={35} slidesPerView={6}
               autoplay={{
                delay: 2500,
                disableOnInteraction: false,
              }}
              modules={[Autoplay]}
              breakpoints={{
                0: {
                  slidesPerView: 2,
                },
                400:{
                  slidesPerView:2,
                },
                639: {
                  slidesPerView: 3,
                },
                865:{
                  slidesPerView:5
                }
              }}
            >
                <SwiperSlide>
                    <img src="images/assets/trusted-logo1.png" alt='trusted-logo' />
                </SwiperSlide>
                <SwiperSlide>
                    <img src="images/assets/trusted-logo2.png" alt='trusted-logo' />
                </SwiperSlide>
                <SwiperSlide>
                    <img src="images/assets/trusted-logo3.png" alt='trusted-logo' />
                </SwiperSlide>
                <SwiperSlide>
                    <img src="images/assets/trusted-logo4.png" alt='trusted-logo' />
                </SwiperSlide>
                <SwiperSlide>
                    <img src="images/assets/trusted-logo5.png" alt='trusted-logo' />
                </SwiperSlide>
                <SwiperSlide>
                    <img src="images/assets/trusted-logo6.png" alt='trusted-logo' />
                </SwiperSlide>
                <SwiperSlide>
                    <img src="images/assets/trusted-logo2.png" alt='trusted-logo' />
                </SwiperSlide>
                <SwiperSlide>
                    <img src="images/assets/trusted-logo3.png" alt='trusted-logo' />
                </SwiperSlide>
                <SwiperSlide>
                    <img src="images/assets/trusted-logo4.png" alt='trusted-logo' />
                </SwiperSlide>
            </Swiper>
        </section>
    </>
  )
}

export default TrustedLogo
